import { type AnyZod, inspect } from './introspect'

// A field's display NAME. Unlike its description (./defaults.ts), this is never derived from the
// declaration: the field key already carries intent a type or format cannot — `contactEmail` reads as
// "Contact Email", where a per-format label would flatten it to "Email" — so a generic fallback word would
// only ever be a downgrade.

// Words a title-cased label should shout rather than capitalise. Without these, `baseUrl` reads as
// "Base Url" — derived-looking in exactly the way that makes an author go and write the label by hand.
const ACRONYMS = new Set(['id', 'url', 'urls', 'api', 'uri', 'ip', 'ipv4', 'ipv6', 'uuid', 'guid', 'jwt',
  'sms', 'html', 'css', 'json', 'xml', 'csv', 'pdf', 'sql', 'ttl', 'sku', 'utm', 'cc', 'bcc', 'crm', 'db'])

// A field key as a human label: `contactEmail` → "Contact Email", `base_url` → "Base URL".
export function humanizeKey(name: string): string {
  return name
    // split camelCase and consecutive-capital runs (`baseURL` → `base URL`)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(word => ACRONYMS.has(word.toLowerCase())
      ? word.toUpperCase()
      : word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

// The label as the console should show it: the author's, else the field key made human.
export const labelOf = (name: string, schema: AnyZod): string =>
  inspect(schema).meta.title || humanizeKey(name) || name
